import contextLayoutMultiLine, {
  LayoutMultiLineContextType,
} from '@contexts/layoutMultiLine'
import useRenderer from '@hooks/useRenderer'
import { desktopCSS, tabletCSS } from '@measures/responsive'
import { NormalContent } from '@widgets/Multiline/types'
import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'

export interface NormalMultilineProps {
  children: NormalContent
}

export type StyledMultilineProps = Pick<
  LayoutMultiLineContextType,
  'isVideoBlock'
>

const { LayoutMultiLineContext } = contextLayoutMultiLine

const StyledMultiline = styled.div<StyledMultilineProps>`
  ${({
    theme: {
      colors: {
        blicktvGrey: { btvGrey_60 },
      },
    },
    isVideoBlock,
  }) => css`
    grid-column: span 6;
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    grid-gap: 20px;

    > * {
      grid-column: span 6;
      min-width: 0;
    }

    ${isVideoBlock &&
    css`
      background-color: ${btvGrey_60};
      ${desktopCSS(css`
        padding: 0 20px;
        margin: 0 -20px;
      `)}
      ${tabletCSS(css`
        padding: 0 52px;
        margin: 0 -52px;
      `)}
    `}
  `}
`

const NormalMultiline: FunctionComponent<NormalMultilineProps> = ({
  children,
}) => {
  const Renderer = useRenderer()
  const layoutMultilineContext = useContext(LayoutMultiLineContext)

  if (!layoutMultilineContext) {
    return null
  }

  const { isVideoBlock } = layoutMultilineContext

  return (
    <StyledMultiline isVideoBlock={isVideoBlock}>
      <Renderer>{children}</Renderer>
    </StyledMultiline>
  )
}

export default NormalMultiline
